var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutDigital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 54,
    viewBox: "0 0 99 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06705 0C8.09936 0 7.32878 0.770574 7.32878 1.73827V37.7043C7.32878 38.672 8.09936 39.4425 9.06705 39.4425H67.523C68.4907 39.4425 69.2612 38.672 69.2612 37.7043V1.73827C69.2612 0.770574 68.4907 0 67.523 0H9.06705ZM65.1754 35.5538H11.3071V3.78118H65.1754V35.5538Z",
    fill: "#005267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.652 40.1934H7.956C7.56175 40.1934 7.16751 40.3546 6.86286 40.6414L0.752041 46.3938C-0.520299 47.5765 0.214434 49.942 1.84518 49.942H74.7807C76.4114 49.942 77.1462 47.5944 75.8738 46.3938L69.763 40.6414C69.4584 40.3546 69.0642 40.1934 68.6699 40.1934H68.652Z",
    fill: "#005267"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1754 35.5539V3.78125H11.3071V35.5539H65.1754ZM37.7216 24.1387H26.0555V22.6871H37.7216V24.1387ZM50.9647 32.1311H38.4563V31.038H50.9647V32.1311ZM62.4874 30.2495H38.4563V29.1564H62.4874V30.2495ZM62.4874 28.3679H38.4563V27.2747H62.4874V28.3679ZM62.4874 26.4862H38.4563V25.3931H62.4874V26.4862ZM38.4563 24.1566V22.7051H50.1224V24.1566H38.4563ZM62.5053 24.1566H50.8392V22.7051H62.5053V24.1566ZM13.6726 6.50513H62.5053V21.4148H13.6726V6.50513ZM13.6726 22.723H25.3387V24.1745H13.6726V22.723ZM13.6726 25.4827H37.7037V32.7942H13.6726V25.4827Z",
    fill: "#F8F9FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5053 6.4707H13.6726V21.3804H62.5053V6.4707Z",
    fill: "#99CBC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3387 22.6875H13.6726V24.1391H25.3387V22.6875Z",
    fill: "#337E84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7037 25.4453H13.6726V32.7568H37.7037V25.4453Z",
    fill: "#337E84"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7395 22.6875H26.0734V24.1391H37.7395V22.6875Z",
    fill: "#337E84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1224 22.6875H38.4563V24.1391H50.1224V22.6875Z",
    fill: "#337E84"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4874 25.3574H38.4563V26.4506H62.4874V25.3574Z",
    fill: "#99CBC7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4874 27.2363H38.4563V28.3295H62.4874V27.2363Z",
    fill: "#99CBC7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4874 29.1387H38.4563V30.2318H62.4874V29.1387Z",
    fill: "#99CBC7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9647 31.0195H38.4563V32.1127H50.9647V31.0195Z",
    fill: "#99CBC7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5053 22.6875H50.8392V24.1391H62.5053V22.6875Z",
    fill: "#337E84"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3241 9C71.8597 9 70.678 10.1817 70.678 11.646V50.5016C70.678 51.9659 71.8597 53.1477 73.3241 53.1477H96.0979C97.5622 53.1477 98.744 51.9659 98.744 50.5016V11.646C98.744 10.1817 97.5622 9 96.0979 9H73.3241ZM84.7174 50.5787C83.8183 50.5787 83.099 49.8594 83.099 48.9602C83.099 48.0611 83.8183 47.3418 84.7174 47.3418C85.6165 47.3418 86.3359 48.0611 86.3359 48.9602C86.3359 49.8594 85.6165 50.5787 84.7174 50.5787ZM94.6079 45.4793H74.8397V12.6479H94.6079V45.4793Z",
    fill: "#005267"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5951 45.4779V12.6465H74.8269V45.4779H94.5951ZM84.589 29.0236H80.7612V27.5593H84.589V29.0236ZM84.833 29.0236V27.5593H88.6608V29.0236H84.833ZM85.0899 35.613H89.0718V36.6149H85.0899V35.613ZM92.7454 40.8023H85.0899V39.8004H92.7454V40.8023ZM92.7454 39.0811H85.0899V38.0792H92.7454V39.0811ZM92.7454 34.8937H85.0899V33.8918H92.7454V34.8937ZM92.7454 33.1725H85.0899V32.1706H92.7454V33.1725ZM92.7454 31.4513H85.0899V30.4494H92.7454V31.4513ZM88.9048 29.0108V27.5465H92.7326V29.0108H88.9048ZM76.7022 14.7017H92.7326V26.506H76.7022V14.7017ZM76.7022 27.5465H80.53V29.0108H76.7022V27.5465ZM76.7022 30.2696H84.088V37.2186H76.7022V30.2696Z",
    fill: "#F8F9FA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.099 48.9602C83.099 49.8594 83.8183 50.5787 84.7174 50.5787C85.6165 50.5787 86.3359 49.8594 86.3359 48.9602C86.3359 48.0611 85.6165 47.3418 84.7174 47.3418C83.8183 47.3418 83.099 48.0611 83.099 48.9602Z",
    fill: "#F8F9FA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7197 14.7031H76.6894V26.5075H92.7197V14.7031Z",
    fill: "#99CBC7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5172 27.5469H76.6894V29.0112H80.5172V27.5469Z",
    fill: "#337E84"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0752 30.2715H76.6894V37.2205H84.0752V30.2715Z",
    fill: "#337E84"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.589 27.5469H80.7612V29.0112H84.589V27.5469Z",
    fill: "#337E84"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6479 27.5469H84.8202V29.0112H88.6479V27.5469Z",
    fill: "#337E84"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7326 30.4648H85.0771V31.4667H92.7326V30.4648Z",
    fill: "#99CBC7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7326 32.1719H85.0771V33.1738H92.7326V32.1719Z",
    fill: "#99CBC7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7326 33.8945H85.0771V34.8964H92.7326V33.8945Z",
    fill: "#99CBC7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.059 35.6152H85.0771V36.6171H89.059V35.6152Z",
    fill: "#99CBC7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7326 38.082H85.0771V39.0839H92.7326V38.082Z",
    fill: "#99CBC7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7326 39.8027H85.0771V40.8046H92.7326V39.8027Z",
    fill: "#99CBC7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7197 27.5469H88.892V29.0112H92.7197V27.5469Z",
    fill: "#337E84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutDigital);
export default __webpack_public_path__ + "static/media/about_digital.d1f7e8773aa41deaccf633a84c3cfa64.svg";
export { ForwardRef as ReactComponent };